import React from 'react';

export default function <T>(value: T | undefined): T | undefined {
  const ref = React.useRef<T | undefined>();
  React.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
